import {lazy} from "react";

export const CreateVoyageTemplateLazy = lazy(() => import('./CreateVoyageTemplate'))
